export default __webpack_public_path__ + "static/media/6.54ba06af.jpg";